import React from 'react';

import { useAppSelector } from 'src/app/hooks';
import {
  selectCurrentArea,
  selectIsFirstArea,
  selectIsLastArea,
  selectPreventNavigation,
} from 'src/state';

import {
  onLeftKeyPress,
  onRightKeyPress,
  onUpKeyPress,
  onDownKeyPress,
} from '../keys';

import { ArrowButton, ArrowDirection } from './ArrowButton';

interface Props {}

export function PlanetControls(props: Props) {
  const preventNavigation = useAppSelector(selectPreventNavigation);
  const currentArea = useAppSelector(selectCurrentArea);
  const isFirstArea = useAppSelector(selectIsFirstArea);
  const isLastArea = useAppSelector(selectIsLastArea);

  let hasPoints = false

  if (currentArea.fields.points) {
    const points = currentArea.fields.points['en-US'];
    if (points.length > 0) {
      hasPoints = true;
    }
  }

  const showUpAndDownArrows = hasPoints;
  const showLeftArrow = !isLastArea;
  const showRightArrow = !isFirstArea;

  return (
    <>
      <ArrowButton
        direction={ArrowDirection.Up}
        onClick={onUpKeyPress}
        hidden={!showUpAndDownArrows}
        disabled={preventNavigation}
      />
      <ArrowButton
        direction={ArrowDirection.Down}
        onClick={onDownKeyPress}
        disabled={preventNavigation}
        hidden={!showUpAndDownArrows}
      />
      <ArrowButton
        direction={ArrowDirection.Left}
        onClick={onLeftKeyPress}
        hidden={!showLeftArrow}
        disabled={preventNavigation}
      />
      <ArrowButton
        direction={ArrowDirection.Right}
        onClick={onRightKeyPress}
        hidden={!showRightArrow}
        disabled={preventNavigation}
      />
    </>
  );
}
